import { Controller } from "@hotwired/stimulus"

import 'tom-select'
import TomSelect from "tom-select"

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {
    if (this.element.tomselect) return;

    if (this.element.getAttribute("multiple") == "multiple") {
      var settings = {
        maxOptions: null,
        plugins: ['remove_button'],
        hidePlaceholder: this.element.dataset.hidePlaceholder == "true" ? true : false
      }
    } else {
      var settings = {
        maxOptions: null,
        allowEmptyOption: true,
        placeholder: this.element.dataset.placeholder || "Choose"
      }
    }

    new TomSelect(this.element, settings);
  }

  disconnect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy();
    }
  }
}
